import Axios from 'axios'

const BASE_URL_V3 = `${process.env.REACT_APP_API_URL}/api/v3/`

const BASE_URL_V3_1 = `${process.env.REACT_APP_API_URL}/api/v3.1/`

export function signIn(data) {
  const url = BASE_URL_V3 + 'admins/login'

  return Axios.post(url, data)
}

export function validateUser(token) {
  const url = BASE_URL_V3 + 'admins/validateSession'

  return Axios.post(url, {}, getConfig(token))
}

export function getCommunity(token) {
  const url = BASE_URL_V3_1 + 'admins/communities'

  return Axios.get(url, getConfig(token))
}

export function resetApartment(token, communityId, apartmentId) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/apartments/' +
    apartmentId +
    '/reset'

  return Axios.patch(url, {}, getConfig(token))
}

export function createUser(token, communityId, apartmentId, data) {
  const url =
    BASE_URL_V3_1 +
    'admins/communities/' +
    communityId +
    '/apartments/' +
    apartmentId +
    '/users'

  return Axios.post(url, data, getConfig(token))
}

export function deleteUser(token, communityId, userId) {
  const url =
    BASE_URL_V3 + 'admins/communities/' + communityId + '/users/' + userId

  return Axios.delete(url, getConfig(token))
}

export function updateUser(token, communityId, userId, data) {
  const url =
    BASE_URL_V3_1 + 'admins/communities/' + communityId + '/users/' + userId

  return Axios.patch(url, data, getConfig(token))
}

export function getLaundrySystem(token, communityId) {
  const url =
    BASE_URL_V3 + 'admins/communities/' + communityId + '/laundrySystems'

  return Axios.get(url, getConfig(token))
}

export function getInformationItems(token, communityId) {
  const url =
    BASE_URL_V3 + 'admins/communities/' + communityId + '/communityInformations'

  return Axios.get(url, getConfig(token))
}

export function updateLaundryTime(token, communityId, laundryTimeId, data) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/laundryTimes/' +
    laundryTimeId

  return Axios.patch(url, data, getConfig(token))
}

export function createLaundryTime(token, communityId, data) {
  const url =
    BASE_URL_V3 + 'admins/communities/' + communityId + '/laundryTimes'

  return Axios.post(url, data, getConfig(token))
}

export function deleteLaundryTime(token, communityId, laundryTimeId) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/laundryTimes/' +
    laundryTimeId

  return Axios.delete(url, getConfig(token))
}

export function updateLaundry(token, communityId, laundryId, data) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/laundries/' +
    laundryId

  return Axios.patch(url, data, getConfig(token))
}

export function createLaundry(token, communityId, data) {
  const url = BASE_URL_V3 + 'admins/communities/' + communityId + '/laundries'

  return Axios.post(url, data, getConfig(token))
}

export function deleteLaundry(token, communityId, laundryId) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/laundries/' +
    laundryId

  return Axios.delete(url, getConfig(token))
}

export function updateLaundryRules(token, communityId, laundryRulesId, data) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/laundryRules/' +
    laundryRulesId

  return Axios.patch(url, data, getConfig(token))
}

//
export function updateInformationItem(token, communityId, informationId, data) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/communityInformations/' +
    informationId

  return Axios.patch(url, data, getConfig(token))
}

export function createInformationItem(token, communityId, data) {
  const url =
    BASE_URL_V3 + 'admins/communities/' + communityId + '/communityInformations'

  return Axios.post(url, data, getConfig(token))
}

export function deleteInformationItem(token, communityId, informationId) {
  const url =
    BASE_URL_V3 +
    'admins/communities/' +
    communityId +
    '/communityInformations/' +
    informationId

  return Axios.delete(url, getConfig(token))
}

export function deleteBooking(token, apartmentId, communityId, bookingId) {
  const url =
    BASE_URL_V3_1 +
    'admins/apartments/' +
    apartmentId +
    '/communities/' +
    communityId +
    '/laundryBookings/' +
    bookingId

  return Axios.delete(url, getConfig(token))
}

export function createBooking(token, apartmentId, communityId, data) {
  const url =
    BASE_URL_V3_1 +
    'admins/apartments/' +
    apartmentId +
    '/communities/' +
    communityId +
    '/laundryBookings'

  return Axios.post(url, data, getConfig(token))
}

// Booking system endpoints
export function createBookingSystem(token, data) {
  const url = BASE_URL_V3 + 'admins/bookableObjects'

  return Axios.post(url, data, getConfig(token))
}

export function getBookingSystem(token, communityId) {
  const url =
    BASE_URL_V3 + 'admins/communities/' + communityId + '/bookableObjects'

  return Axios.get(url, getConfig(token))
}

export function deleteBookingSystem(token, bookableId) {
  const url = BASE_URL_V3 + 'admins/bookableObjects/' + bookableId

  return Axios.delete(url, getConfig(token))
}

export function updateBookingSystem(token, bookableId, data) {
  const url = BASE_URL_V3 + 'admins/bookableObjects/' + bookableId

  return Axios.patch(url, data, getConfig(token))
}

// Booking system time endpoints
export function createBookingSystemTime(token, bookableId, data) {
  const url = BASE_URL_V3 + 'admins/bookableObjects/' + bookableId + '/times'

  return Axios.post(url, data, getConfig(token))
}

export function deleteBookingSystemTime(token, bookableId, timeId) {
  const url =
    BASE_URL_V3 + 'admins/bookableObjects/' + bookableId + '/times/' + timeId

  return Axios.delete(url, getConfig(token))
}

export function updateBookingSystemTime(token, bookableId, timeId, data) {
  const url =
    BASE_URL_V3 + 'admins/bookableObjects/' + bookableId + '/times/' + timeId

  return Axios.patch(url, data, getConfig(token))
}

// Post endpoints
export function createPost(token, communityId, data) {
  const url = BASE_URL_V3 + '/admins/communities/' + communityId + '/posts'

  return Axios.post(url, data, getConfig(token))
}

export function getPosts(token, communityId) {
  const url = BASE_URL_V3 + 'admins/communities/' + communityId + '/posts'

  return Axios.get(url, getConfig(token))
}

export function deletePost(token, communityId, postId) {
  const url =
    BASE_URL_V3 + '/admins/communities/' + communityId + '/posts/' + postId

  return Axios.delete(url, getConfig(token))
}

export function deleteComment() {}

// Templates
export function getApartmentPdf(code, apartment, community) {
  const url = `${BASE_URL_V3_1}admins/template/getPdf/${code}/${apartment}/${community}`

  window.open(url, '_blank')
}

export function getBulkApartmentPdf(token, communityId, communityName) {
  const url = BASE_URL_V3_1 + 'admins/communities/' + communityId + '/bulk-pdf'

  return Axios.get(url, {
    ...getConfig(token),
    responseType: 'blob',
    timeout: 120000
  }).then(response => {
    const blob = new Blob([response.data], { type: 'application/pdf' })
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = 'manualer-' + communityName + '.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(downloadUrl)
  })
}

export function toggleLaundryVisibility(token, communityId, showApartmentInLaundry) {
  const url = BASE_URL_V3 + `admins/communities/${communityId}/laundry-visibility`
  return Axios.put(url, { showApartmentInLaundry }, getConfig(token))
}

function getConfig(token) {
  return { headers: { authorization: 'Bearer ' + token } }
}



// WEBPACK FOOTER //
// ./src/components/actions/api/index.js